export default __webpack_public_path__ + "assets/5ce2631c76a09ec2ab1d619e3b1eda91.woff2";